import React, { useEffect, useState } from 'react';
import { ThreeDots } from 'react-loader-spinner'
import { JcSize } from '../utils/JcUtils';


const DEFAULT_LOADING_INDICATOR_DELAY_MS = 200;

export interface JcLoadingIndicatorProps {
    size?: JcSize;
    delayMs?: number;
}

const getIndicatorSize = (size: JcSize): number => {
    if (size === JcSize.EXTRA_SMALL) {
        return 16;
    }
    else if (size === JcSize.SMALL) {
        return 32;
    }
    else if (size === JcSize.MEDIUM) {
        return 48;
    }
    else if (size === JcSize.LARGE) {
        return 64;
    }
    else if (size === JcSize.EXTRA_LARGE) {
        return 128;
    }
    else {
        return 256;
    }

}

export const JcLoadingIndicator: React.FunctionComponent<JcLoadingIndicatorProps> = (props: JcLoadingIndicatorProps) => {

    const sizeNum = getIndicatorSize(props.size ?? JcSize.LARGE);
    const delayMs = props.delayMs ?? DEFAULT_LOADING_INDICATOR_DELAY_MS;
    const [visible, setVisible] = useState(delayMs <= 0);

    useEffect(() => {
        if (delayMs <= 0) {
            return;
        }
        const timeout = setTimeout(() => setVisible(true), delayMs);
        return () => clearTimeout(timeout);
    }, [delayMs]);

    if (!visible) {
        return <></>;
    }

    return <ThreeDots height={sizeNum}
        width={sizeNum}
        color="var(--jc-app-text-color)" />
}